module.exports = __webpack_public_path__ + "static/media/ace_of_clubs.9ee19a01.svg";